module.exports = __webpack_public_path__ + "static/media/handsetIcon.cbd23d7c.png";